import type { unlockSchema } from "@/schemas/unlockSchema";
import { type UnlockUserResponse } from "@/types";
import { API_WEB_FULLERETTE } from "@/config/index"
import type z from "zod";

export async function unlockUser({ phoneNumber }: z.infer<typeof unlockSchema>) {
    try {
        const body = new URLSearchParams({
            phoneNumber
        })

        const api = `${API_WEB_FULLERETTE}DesbloqueoAd`
        const response = await fetch(api, { method: "POST", body })

        const data: UnlockUserResponse = await response.json()

        return {
            status: response.status,
            data
        }
    } catch (error) {
        console.error("unlockUser error:", error)
        return {
            status: 0,
            data: {
                reason: "USER_INFO_ERROR",
                message: "Network or unexpected error"
            } satisfies UnlockUserResponse
        }
    }
}
